import _ = require('underscore');
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IUserNotificationSetting } from '../../models/IUserNotificationsSettingsInfo';
import { UserNotificationSettingsLayer } from '../../models/UserNotificationSettingsLayer';

export interface IUpdateNotificationSettingsRequestParams {
  settings: IUserNotificationSetting[];
  siteId?: string;
}

export class UpdateNotificationSettingsRequest extends Request<IUpdateNotificationSettingsRequestParams, void> {
  constructor(layer: UserNotificationSettingsLayer, updatedSettings: IUserNotificationSetting[], siteId?: string) {
    const requestMap: Record<UserNotificationSettingsLayer, string> = {
      [UserNotificationSettingsLayer.User]: 'updateNotificationSettingsForUser',
      [UserNotificationSettingsLayer.Site]: 'updateNotificationSettingsForSite',
      [UserNotificationSettingsLayer.Server]: 'updateNotificationSettingsForServer'
    };

    super(requestMap[layer],
      { settings: updatedSettings, ...(siteId ? { siteId } : {}) });
  }
}